export default "__VITE_ASSET__BMpGMJdR__"